import { render, staticRenderFns } from "./collapsed-job-types.vue?vue&type=template&id=5c49e23b"
import script from "./collapsed-job-types.vue?vue&type=script&lang=js"
export * from "./collapsed-job-types.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports